import styled, { css } from 'styled-components'

const Container = styled.div`
  ${props => (props.thumbnail ? 'display: flex' : '')};
  ${props => (props.thumbnail ? 'justify-content: center' : '')};
  ${props => (props.thumbnail ? 'align-items: center' : '')};
  ${props => (props.thumbnail ? 'flex-direction: column' : '')};
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  ${props => (props.thumbnail ? 'width: 80%' : 'width: 100px')};
  ${props => (props.thumbnail ? 'height: 70%' : 'height: 100px')};
  ${props =>
    props.isFullSize &&
    css`
      width: 100%;
      height: 100%;
    `};

  margin: auto;
  > a,
  button {
    display: flex;
    flex-direction: column;
    border: none;
    padding: ${props => (props.iosAR && props.thumbnail ? '5px 5px' : '5px 10px')};
    background-color: transparent;
    align-items: center;
    font-family: ${props => props.theme.font.family.base};
    font-size: 24px;
    font-weight: 600;
    justify-content: center;
    ${props => (props.thumbnail || props.isFullSize ? 'width: 100%' : '')};
    ${props => (props.thumbnail || props.isFullSize ? 'height: 100%' : '')};
  }
`

const IosText = styled.div`
  font-size: ${props => (props.thumbnail ? '12px' : props.theme.font.size.base)};
  text-align: center;
  color: initial;
  ${props => (props.thumbnail ? 'line-height: 1rem' : '')};
`

export { Container, IosText } // eslint-disable-line
